module.exports = __webpack_public_path__ + "img/1f43b-200d-2744-fe0f.36cefc3.svg";